export const GET_OBJECT_LINKS_COMPLETED = 'GET_OBJECT_LINKS_COMPLETED' as const;
export const GET_OBJECT_LINKS_FAILED = 'GET_OBJECT_LINKS_FAILED' as const;
export const REMOVE_OBJECT_LINKS_FROM_STATE = 'REMOVE_OBJECT_LINKS_FROM_STATE' as const;
